import React from 'react';
import shapesIcons from '@/components/common/Forms/Questions/Drawing/Toolbar/ShapesButton/icons';
import I18n from 'i18n-js';
import { className } from './ShapeCategory';
import { listItemStyle } from '../styles';
import useDrawingContext from '../../store/useDrawingContext';

interface ImageCategoryProps {
  category: string;
  setCategory: (category: string) => void;
}

const ImageCategory = ({ category, setCategory }: ImageCategoryProps) => {
  const title = 'Images';
  const categoryId = 10;
  const toolbarEl = useDrawingContext(state => state.toolbarEl);

  return (
    <button
      aria-haspopup="menu"
      className={className(category === title)}
      style={listItemStyle(toolbarEl)}
      type="button"
      onClick={() => {
        setCategory(title);
      }}
    >
      {shapesIcons[categoryId]()}
      <span className="tw-px-4">{I18n.t(title.toLowerCase())}</span>
    </button>
  );
};

export default ImageCategory;
